class Appcues {
  static checkAppcues () {
    return window && window.Appcues
  }

  static updateMetadata = ({
    userId,
    companyId,
    merchantId,
    accountId,
    accountName,
    accountType,
    userEmail,
    businessModel
  }) => {
    if (!this.checkAppcues()) {
      // eslint-disable-next-line no-console
      console.warn('window.Appcues not found')
      return
    }
    try {
      window.Appcues.identify(userId, {
        companyId,
        merchantId,
        accountId,
        accountName,
        accountType,
        userEmail,
        businessModel
      })
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Appcues identify error: ', error)
    }
  }

  static initialPage () {
    if (!this.checkAppcues()) {
      // eslint-disable-next-line no-console
      console.warn('window.Appcues not found')
      return
    }
    try {
      window.Appcues.page()
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Appcues initialPage error: ', error)
    }
  }
}

export default Appcues
